import { SET_STYLE_PARAMS } from './style-params-actions';

export const styleParams = (state = {}, action = {}) => {
  if (action.type === SET_STYLE_PARAMS) {
    return action.payload;
  } else {
    return state;
  }
};
